<template>
  <div class="goods1">
    <div class="mb20">
      点击获取坐标按钮来查询对应的坐标(例如：116.43,39.91)。二维码像素推荐200*200像素。
    </div>
    <el-form :model="currentInfo" label-width="80px">
      <el-form-item label="电话">
        <el-input placeholder="请输入电话" v-model="currentInfo.title" />
      </el-form-item>
      <el-form-item label="二维码">
        <el-upload
          :action="fileObj.url"
          :before-upload="beforeUpload"
          :on-success="successUpdate"
          :headers="reqData"
          :show-file-list="false"
        >
          <img
            class="list-img"
            v-if="currentInfo.picture"
            :src="currentInfo.picture"
            @click="updateImg()"
          />
          <i class="el-icon-plus" v-else />
        </el-upload>
      </el-form-item>
      <el-form-item label="校区">
        <el-input placeholder="请输入校区" v-model="currentInfo.remark" />
      </el-form-item>
      <el-form-item label="地址">
        <el-input placeholder="请输入地址" v-model="currentInfo.content" />
      </el-form-item>
      <div class="jc-center mt20 mb20">
        <el-button type="primary">
          <a
            class="color-gray-1"
            href="http://api.map.baidu.com/lbsapi/getpoint/index.html"
            target="_blank"
            >获取坐标</a
          ></el-button
        >
      </div>
      <el-form-item label="坐标">
        <el-input
          placeholder="请输入坐标"
          v-model.lazy="currentInfo.abscissa"
        />
      </el-form-item>

      <div>请上传轮播图，推荐尺寸380*360</div>
      <div
        class="mt20 wx-item-style"
        v-for="(item, index) in currentInfo.wxSchoolPageItemList"
        :key="index"
      >
        <div class="flex mt10 jc-sb wx-item-style">
          <el-upload
            :action="fileObj.url"
            :before-upload="beforeUpload"
            :on-success="successListUpdate"
            :headers="reqData"
            :show-file-list="false"
          >
            <img
              class="list-img"
              :src="item.picture"
              @click="updateImg(index)"
              v-if="item.picture"
            />
            <div @click="updateImg(index)" v-else class="addIcon">
              <i class="el-icon-plus" />
            </div>
          </el-upload>

          <el-button type="danger" @click="deleteBtn(index)" v-if="item.picture"
            >删除<i class="el-icon-delete"
          /></el-button>
        </div>
        <!-- <div class="jc-center mt20">
          <el-button type="primary" @click="addBannerBtn()">添加</el-button>
        </div> -->
      </div>
    </el-form>
  </div>
</template>
<script>
import { codeMixin } from "../../../minix";
export default {
  mixins: [codeMixin],
  methods: {
    deleteBtn(index) {
      this.currentInfo.wxSchoolPageItemList[index].isEmpty = 1;
      this.currentInfo.wxSchoolPageItemList[index].picture = "";
    },
  },
};
</script>
<style lang="less" scoped>
.goods1 {
  /deep/ .el-upload {
    width: 100px;
    height: 100px;
    border: 1px dashed rgb(196, 192, 192);
    display: flex;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    .el-icon-plus {
      font-size: 36px;
    }
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
    .addIcon {
      width: 100px;
      height: 100px;
      .el-icon-plus {
        line-height: 106px;
      }
    }
  }
  .jc-sb {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    margin-top: 10px;
    border-radius: 6px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/module/module3/setting.vue